(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceCategoryCustom', ServiceCategoryCustom);

    ServiceCategoryCustom.$inject = ['$resource'];

    function ServiceCategoryCustom($resource) {


        var getServiceCategoriesByCurrentCompany = function () {
            //
            var resourceUrl = 'api/service-categories-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceCategoriesByCompanyId = function (companyId) {
            //
            var resourceUrl = 'api/get-categories-by-company-id?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getServiceCategoriesByCurrentCompany_get = function () {

            var resourceUrl = 'api/service-categories-by-current-company';
            return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        }


        var checkCategoriesAndServicesByCurrentCompany = function () {
            //
            var resourceUrl = 'api/check-categories-and-services-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            getServiceCategoriesByCurrentCompany: getServiceCategoriesByCurrentCompany,
            getServiceCategoriesByCompanyId: getServiceCategoriesByCompanyId,
            getServiceCategoriesByCurrentCompany_get: getServiceCategoriesByCurrentCompany_get,
            checkCategoriesAndServicesByCurrentCompany: checkCategoriesAndServicesByCurrentCompany
        };
    }
})();
